<template>
    <div class="flex flex-col gap-y-2">
        <TruncateTooltip>
            <DynamicLink v-if="item.url" :href="item.url">
                <p
                    v-text="item.name"
                    class="underline-hover text-gray-900 font-header text-2xl font-semibold"
                ></p
            ></DynamicLink>
        </TruncateTooltip>

        <div class="flex items-center justify-between gap-x-2">
            <div class="flex items-center gap-x-2">
                <p
                    v-text="$moment(item.created_at).format('L')"
                    :class="['shrink-0 text-sm']"
                />
            </div>
        </div>

        <!-- ModelImage if there is an image -->
        <ModelImage
            :src="item.image"
            :alt="item.name"
            modelClass="image"
            :typeId="item.type_id"
            fallbackBorder="border border-gray-200 rounded-lg"
            imageClasses="max-w-full aspect-video rounded-lg"
        />

        <!-- Description -->
        <TruncateTooltip v-if="item.description" maxWidth="max-w-[34rem]">
            <p
                v-text="item.short_description || item.description"
                class="line-clamp-2"
            />
        </TruncateTooltip>
    </div>
</template>

<script>
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
import TruncateTooltip from '@/Components/Utilities/TruncateTooltip.vue'
import YoutubeEmbed from '@/Components/Elements/YoutubeEmbed.vue'
import ModelInteractions from '@/Components/ModelComponents/Interactions/ModelInteractions.vue'
import TypeTag from '@/Components/Elements/Tags/TypeTag.vue'
import { Link } from '@inertiajs/vue3'
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import DynamicLink from '@/Components/Utilities/DynamicLink.vue'
import ResourceListItem from '@/Components/Panels/ResourcePanel/ResourceListItem.vue'
import ResourceFile from '@/Pages/Resource/ShowPageComponents/ResourceFile.vue'
import { PhArrowRight, PhDotsThreeOutline } from '@phosphor-icons/vue'
import ButtonPopoverMenu from '@/Components/Utilities/ButtonPopoverMenu.vue'

export default {
    name: 'FeedItem',

    components: {
        ModelImage,
        Link,
        TruncateTooltip,
        YoutubeEmbed,
        TypeTag,
        ModelInteractions,
        PrimaryButton,
        DynamicLink,
        ResourceListItem,
        ResourceFile,
        ButtonPopoverMenu,
        PhArrowRight,
        PhDotsThreeOutline,
    },

    emits: ['deleteModel'],

    props: {
        title: {
            type: String,
            default: 'Related resources',
        },
        item: {
            type: Object,
            default: () => {
                return {
                    image: null,
                    name: null,
                    created_at: null,
                    type: null,
                    type_id: null,
                }
            },
            validator: (value) => {
                return (
                    Object.hasOwn(value, 'name') &&
                    Object.hasOwn(value, 'created_at') &&
                    Object.hasOwn(value, 'url') &&
                    Object.hasOwn(value, 'type') &&
                    Object.hasOwn(value, 'type_id')
                )
            },
        },
    },

    data() {
        return {
            isHovering: false,
        }
    },
}
</script>
